export const Overline = ({ children, className = '' }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.2em] text-steel-label ${className}`}>
    {children}
  </p>
);
